import { render } from "./bookmarkWidget.vue?vue&type=template&id=8e5f6546&scoped=true"
import script from "./bookmarkWidget.vue?vue&type=script&lang=js"
export * from "./bookmarkWidget.vue?vue&type=script&lang=js"

import "./bookmarkWidget.vue?vue&type=style&index=0&id=8e5f6546&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8e5f6546"

export default script